import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { setAuthorization } from "config/configInitializer";
import { useSelector } from "react-redux";
import { useProfile } from "hooks/useProfile";
import { logoutUser } from "slices/thunks";
import { useGlobalHooks } from "hooks/useGlobalHooks";

const AuthProtected = ({ allowedRoles, children }: any) => {
  const { dispatch } = useGlobalHooks();

  const { userProfile, loading } = useProfile();
  const { authData, authLoading } = useSelector(
    (state: any) => state.Dashboard,
  );

  const userRole = authData?.userRoleType || "Partner";
  const hostname = window.location.hostname.toLowerCase();

  const isInvestProd = hostname === "partner.triveinvest.co.id";

  useEffect(() => {
    if (userProfile && !loading) {
      setAuthorization(userProfile);
    } else if (!userProfile && loading) {
      dispatch(logoutUser());
    }
  }, [userProfile, loading, dispatch]);

  // Redirect to login if user is not authenticated
  if (!userProfile) {
    return <Navigate to={`/login${isInvestProd ? "/id" : ""}`} />;
  }

  // Check if the user has access to the route based on role
  if (authData.$id && allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" />;
  }

  return <>{children}</>;
};

export default AuthProtected;
